const Coordinate02Icon = /*#__PURE__*/ [
  ["path", { d: "M13.5 2L12 3.5M12 3.5V5M12 3.5L10.5 2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 14H5L2 17H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 14L22 17M22 14L19 17", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 8V16M12 16L3 22M12 16L21 22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export { Coordinate02Icon as default };
//# sourceMappingURL=Coordinate02Icon.js.map
